import React from "react";
import Tooltip from "@mui/material/Tooltip";
import {
  ChartXAxisZoomUpIcon,
  ChartXAxisZoomOutIcon,
  ChartYAxisZoomUpIcon,
  ChartYAxisZoomOutIcon,
} from "../../../../../icon/ChartAxisZoomIcon";

type ButtonProps = {
  /**
   * ツールチップ
   */
  tooltip: string;
  /**
   * ボタンアイコン
   */
  icon: JSX.Element;
  /**
   * ボタンがクリックされた場合に呼び出されます
   */
  onClick?: () => void;
};

/**
 * チャート軸Zoomボタンを表示します
 * @param {ButtonProps} props - ボタンパラメータ
 * @returns チャート軸Zoomボタン
 */
function ChartAxisZoomButton(props: ButtonProps) {
  return (
    <Tooltip title={props.tooltip} placement="left" arrow>
      <button
        style={{ border: "0", padding: "0", margin: "0" }}
        onClick={props.onClick}
      >
        {props.icon}
      </button>
    </Tooltip>
  );
}

export interface ChartZoomMenuParam {
  /**
   * X軸拡大ボタンがクリックされた場合に呼び出されます
   */
  onXZoomUp?: () => void;
  /**
   * X軸縮小ボタンがクリックされた場合に呼び出されます
   */
  onXZoomOut?: () => void;
  /**
   * Y軸拡大ボタンがクリックされた場合に呼び出されます
   */
  onYZoomUp?: () => void;
  /**
   * Y軸縮小ボタンがクリックされた場合に呼び出されます
   */
  onYZoomOut?: () => void;
}

/**
 * チャートZoomメニューを表示します
 * @param {ChartZoomMenuParam} props - Zoomメニューパラメータ
 * @returns チャートZoomメニュー
 */
export default function ChartZoomMenu(props: ChartZoomMenuParam) {
  const { onXZoomUp, onXZoomOut, onYZoomUp, onYZoomOut } = props;
  return (
    <React.Fragment>
      <div style={{ marginTop: "25px" }}>
        <ChartAxisZoomButton
          tooltip="x zoom up"
          icon={<ChartXAxisZoomUpIcon />}
          onClick={onXZoomUp}
        />
      </div>
      <div>
        <ChartAxisZoomButton
          tooltip="x zoom out"
          icon={<ChartXAxisZoomOutIcon />}
          onClick={onXZoomOut}
        />
      </div>
      <div>
        <ChartAxisZoomButton
          tooltip="y zoom up"
          icon={<ChartYAxisZoomUpIcon />}
          onClick={onYZoomUp}
        />
      </div>
      <div>
        <ChartAxisZoomButton
          tooltip="y zoom out"
          icon={<ChartYAxisZoomOutIcon />}
          onClick={onYZoomOut}
        />
      </div>
    </React.Fragment>
  );
}
